import { render } from "./UserDash.vue?vue&type=template&id=331a560c"
import script from "./UserDash.vue?vue&type=script&lang=js"
export * from "./UserDash.vue?vue&type=script&lang=js"

import "./UserDash.vue?vue&type=style&index=0&id=331a560c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__